// extracted by mini-css-extract-plugin
module.exports = {"LoginPage":"LoginPage_LoginPage__3wZAa","main":"LoginPage_main__2oH03"};